<template>
  <div>
    <section class="fullwidth">
      <div :class="[item[1]]" v-for="item in [
        ['home', 'part-first'],
        ['away', 'part-last'],]"
        :key="item.$index">
        <ul>
          <li v-for="statsKey in statsOrder" :key="statsKey.key">
            <ul>
              <li v-for="(val, key) in match.stats" :key="key" v-if="key === statsKey.key">
                <span class="silent" v-if="item[0] == 'home'">{{key | capitalise}}: </span>
                <span class="min-30">{{val[item[0]]}}</span>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </section>
    <div class="sub-menu sticky" v-if="sections.length > 1">
      <ul>
        <li
          v-for="section in sections" :key="section.key"
          :class="{active: section.value == activeSection.value}"
          @click="activeSection = section">{{section.value | capitalise}}</li>
      </ul>
    </div>
    <div v-if="activeSection.isLiveStats">
      <section class="fullwidth stats-table with-border">
        <table>
          <col>
          <col>
          <col>
          <colgroup span="4"></colgroup>
          <colgroup span="3"></colgroup>
          <colgroup span="2"></colgroup>
          <colgroup span="3"></colgroup>
          <tr class="head">
            <th rowspan="2"></th>
            <th colspan="3"></th>
            <th colspan="6" scope="colgroup">Goal</th>
            <th colspan="3" scope="colgroup">Card</th>
            <th colspan="2" scope="colgroup">Foul</th>
            <th colspan="3" scope="colgroup">Penalty</th>
          </tr>
          <tr class="head second-row">
            <th scope="col">Min</th>
            <th scope="col">CS</th>
            <th scope="col">CS(MR)</th>
            <th scope="col">S</th>
            <th scope="col">A</th>
            <th scope="col">C</th>
            <th scope="col">OG</th>
            <th scope="col">AD</th>
            <th scope="col">OGA</th>
            <th scope="col">R</th>
            <th scope="col">Y</th>
            <th scope="col">Y2</th>
            <th scope="col">Drw</th>
            <th scope="col">Com</th>
            <th scope="col">Sco</th>
            <th scope="col">Sav</th>
            <th scope="col">Mis</th>
          </tr>
          <template v-for="team in [match.info.home, match.info.away]">
            <template v-for="role in roleOrder">
              <tr>
                <th class="subtitle" colspan="18">{{team.name}} - {{role.name}}</th>
              </tr>
              <tr class="stats-row"
                v-for="playerKey in match.teams[team.key].players"
                xxif="match.players[playerKey].stats.minutes_played > 0 && match.players[playerKey].role == role.key"
                v-if="shouldShow(match.players[playerKey], role)"
                :key="playerKey">
                <th
                  scope="row"
                  @click="onPlayerSelected(playerKey)"
                  class="clickable">{{match.players[playerKey].jersey_name}} <small v-if="role.keys == null">{{match.players[playerKey].role}}</small></th>
                <td>{{match.players[playerKey].stats.minutes_played}}</td>
                <td v-if="match.players[playerKey].stats.clean_sheet">✓</td>
                <td v-else>✕</td>
                <td v-if="match.players[playerKey].stats.clean_sheet_by_match_role">✓</td>
                <td v-else>✕</td>
                <td>{{match.players[playerKey].stats.goal.scored}}</td>
                <td>{{match.players[playerKey].stats.goal.assist}}</td>
                <td>{{match.players[playerKey].stats.goal.conceded}}</td>
                <td>{{match.players[playerKey].stats.goal.own_goal_conceded}}</td>
                <td>{{match.players[playerKey].stats.goal.assist_drawn}}</td>
                <td>{{match.players[playerKey].stats.goal.own_goal_assist}}</td>
                <td>{{match.players[playerKey].stats.card.RC}}</td>
                <td>{{match.players[playerKey].stats.card.YC}}</td>
                <td>{{match.players[playerKey].stats.card.Y2C}}</td>
                <td>{{match.players[playerKey].stats.foul.drawn}}</td>
                <td>{{match.players[playerKey].stats.foul.committed}}</td>
                <td>{{match.players[playerKey].stats.penalty.scored}}</td>
                <td>{{match.players[playerKey].stats.penalty.saved}}</td>
                <td>{{match.players[playerKey].stats.penalty.missed}}</td>
              </tr>
            </template>
          </template>
        </table>
      </section>
    </div>
    <div v-if="activeSection.isOverview">
      <div class="sub-menu sticky" v-if="overviewActions.length > 1">
        <ul class="stats-links">
          <li
            v-for="section in overviewActions" :key="section.key"
            :class="{active: section.value == overviewActiveSection.value}"
            @click="overviewActiveSection = section">{{section.value | capitalise}}</li>
        </ul>
      </div>
      <div v-if="overviewActiveSection.isSummary">
        <section class="fullwidth stats-table with-border">
          <table>
            <col>
            <col>
            <col>
            <colgroup span="4"></colgroup>
            <colgroup span="3"></colgroup>
            <colgroup span="2"></colgroup>
            <colgroup span="3"></colgroup>
            <tr class="head">
              <th rowspan="2"></th>
              <th colspan="1"></th>
              <th colspan="4" scope="colgroup">Goal</th>
              <th colspan="1"></th>
            </tr>
            <tr class="head second-row">
              <th scope="col">Min</th>
              <th scope="col">S</th>
              <th scope="col">A</th>
              <th scope="col">C</th>
              <th scope="col">OG</th>
              <th scope="col">Tackles</th>
            </tr>
            <template v-for="team in [match.info.home, match.info.away]">
              <template v-for="role in roleOrder">
                <tr>
                  <th class="subtitle" colspan="15">{{team.name}} - {{role.name}}</th>
                </tr>
                <tr class="stats-row"
                  v-for="playerKey in match.teams[team.key].players"
                  xxif="match.players[playerKey].stats.minutes_played > 0 && match.players[playerKey].role == role.key"
                  v-if="shouldShow(match.players[playerKey], role)"
                  :key="playerKey">
                  <th
                    scope="row"
                    @click="onPlayerSelected(playerKey)"
                    class="clickable">{{match.players[playerKey].jersey_name}} <small v-if="role.keys == null">{{match.players[playerKey].role}}</small></th>
                  <td>{{match.players[playerKey].stats.minutes_played}}</td>
                  <td>{{match.players[playerKey].stats.goal.scored}}</td>
                  <td>{{match.players[playerKey].stats.goal.assist}}</td>
                  <td>{{match.players[playerKey].stats.goal.conceded}}</td>
                  <td>{{match.players[playerKey].stats.goal.own_goal_conceded}}</td>
                  <td>{{match.players[playerKey].stats.tackles}}</td>
                </tr>
              </template>
            </template>
          </table>
        </section>
      </div>
      <div v-if="overviewActiveSection.isAttack || overviewActiveSection.isDefence || overviewActiveSection.isPassing">
        <section class="fullwidth stats-table with-border">
          <table>
            <col>
            <col>
            <col>
            <colgroup span="4"></colgroup>
            <colgroup span="3"></colgroup>
            <colgroup span="2"></colgroup>
            <colgroup span="3"></colgroup>
            <tr class="head">
              <th rowspan="2"></th>
              <th rowspan="1" v-if="overviewActiveSection.isAttack">Shot on target</th>
              <th rowspan="1" v-else-if="overviewActiveSection.isDefence">Tackles</th>
              <th rowspan="1" v-else>Passes</th>
              <th rowspan="1" v-if="overviewActiveSection.isAttack">OG Ass</th>
              <th rowspan="1" v-if="overviewActiveSection.isAttack">Ass Dwn</th>
              <th rowspan="1" v-if="overviewActiveSection.isAttack">Reb Ass</th>
            </tr>
            <tr class="head second-row">
            </tr>
            <template v-for="team in [match.info.home, match.info.away]">
              <template v-for="role in roleOrder">
                <tr>
                  <th class="subtitle" colspan="15">{{team.name}} - {{role.name}}</th>
                </tr>
                <tr class="stats-row"
                  v-for="playerKey in match.teams[team.key].players"
                  xxif="match.players[playerKey].stats.minutes_played > 0 && match.players[playerKey].role == role.key"
                  v-if="shouldShow(match.players[playerKey], role)"
                  :key="playerKey">
                  <th
                    scope="row"
                    @click="onPlayerSelected(playerKey)"
                    class="clickable">{{match.players[playerKey].jersey_name}} <small v-if="role.keys == null">{{match.players[playerKey].role}}</small></th>
                  <td v-if="overviewActiveSection.isAttack">{{match.players[playerKey].stats.shot_on_target}}</td>
                  <td v-else-if="overviewActiveSection.isDefence">{{match.players[playerKey].stats.tackles}}</td>
                  <td v-else>{{match.players[playerKey].stats.passes}}</td>

                  <td v-if="overviewActiveSection.isAttack && match.players[playerKey].stats.goal.own_goal_assist">{{match.players[playerKey].stats.goal.own_goal_assist}}</td>
                  <td v-else-if="overviewActiveSection.isAttack">-</td>

                  <td v-if="overviewActiveSection.isAttack && match.players[playerKey].stats.goal.assist_drawn">{{match.players[playerKey].stats.goal.assist_drawn}}</td>
                  <td v-else-if="overviewActiveSection.isAttack">-</td>

                  <td v-if="overviewActiveSection.isAttack && match.players[playerKey].stats.goal.rebound_assist">{{match.players[playerKey].stats.goal.rebound_assist}}</td>
                  <td v-else-if="overviewActiveSection.isAttack && match.players[playerKey].stats.goal.rebound_assist===0">{{match.players[playerKey].stats.goal.rebound_assist}}</td>
                  <td v-else-if="overviewActiveSection.isAttack">-</td>
                </tr>
              </template>
            </template>
          </table>
        </section>
      </div>
      <div v-if="overviewActiveSection.isFouls">
        <section class="fullwidth stats-table with-border">
          <table>
            <col>
            <col>
            <col>
            <colgroup span="4"></colgroup>
            <colgroup span="3"></colgroup>
            <colgroup span="2"></colgroup>
            <colgroup span="3"></colgroup>
            <tr class="head">
              <th rowspan="2"></th>
              <th colspan="2">Fouls</th>
            </tr>
            <tr class="head second-row">
              <th scope="col">Drw</th>
              <th scope="col">Com</th>
            </tr>
            <template v-for="team in [match.info.home, match.info.away]">
              <template v-for="role in roleOrder">
                <tr>
                  <th class="subtitle" colspan="15">{{team.name}} - {{role.name}}</th>
                </tr>
                <tr class="stats-row"
                  v-for="playerKey in match.teams[team.key].players"
                  xxif="match.players[playerKey].stats.minutes_played > 0 && match.players[playerKey].role == role.key"
                  v-if="shouldShow(match.players[playerKey], role)"
                  :key="playerKey">
                  <th
                    scope="row"
                    @click="onPlayerSelected(playerKey)"
                    class="clickable">{{match.players[playerKey].jersey_name}} <small v-if="role.keys == null">{{match.players[playerKey].role}}</small></th>
                  <td>{{match.players[playerKey].stats.foul.drawn}}</td>
                  <td>{{match.players[playerKey].stats.foul.committed}}</td>
                </tr>
              </template>
            </template>
          </table>
        </section>
      </div>
      <div v-if="overviewActiveSection.isGoalkeeper">
        <section class="fullwidth stats-table with-border">
          <table>
            <col>
            <col>
            <col>
            <colgroup span="4"></colgroup>
            <colgroup span="3"></colgroup>
            <colgroup span="2"></colgroup>
            <colgroup span="3"></colgroup>
            <tr class="head">
              <th rowspan="2"></th>
              <th colspan="4" scope="colgroup">Goal</th>
            </tr>
            <tr class="head second-row">
              <th scope="col">S</th>
              <th scope="col">A</th>
              <th scope="col">C</th>
              <th scope="col">OG</th>
            </tr>
            <template v-for="team in [match.info.home, match.info.away]">
              <template v-for="role in roleOrder">
                <tr v-if="role.name === 'Goalkeepers'">
                  <th class="subtitle" colspan="15">{{team.name}} - {{role.name}}</th>
                </tr>
                <tr class="stats-row"
                  v-for="playerKey in match.teams[team.key].players" :key="playerKey"
                  xxif="match.players[playerKey].stats.minutes_played > 0 && match.players[playerKey].role == role.key"
                  v-if="shouldShow(match.players[playerKey], role) && match.players[playerKey].role.value === 'goalkeeper'">
                  <th
                    scope="row"
                    @click="onPlayerSelected(playerKey)"
                    class="clickable">{{match.players[playerKey].jersey_name}} <small v-if="role.keys == null">{{match.players[playerKey].role}}</small></th>
                  <td>{{match.players[playerKey].stats.goal.scored}}</td>
                  <td>{{match.players[playerKey].stats.goal.assist}}</td>
                  <td>{{match.players[playerKey].stats.goal.conceded}}</td>
                  <td>{{match.players[playerKey].stats.goal.own_goal_conceded}}</td>
                </tr>
              </template>
            </template>
          </table>
        </section>
      </div>
      <div v-if="overviewActiveSection.isShootout">
        <section class="fullwidth stats-table with-border">
          <table>
            <col>
            <col>
            <col>
            <colgroup span="4"></colgroup>
            <colgroup span="3"></colgroup>
            <colgroup span="2"></colgroup>
            <colgroup span="3"></colgroup>
            <tr class="head">
              <th rowspan="2"></th>
              <th colspan="3">Shootout</th>
            </tr>
            <tr class="head second-row">
              <th scope="col">Missed</th>
              <th scope="col">Saved</th>
              <th scope="col">Scored</th>
            </tr>
            <template v-for="team in [match.info.home, match.info.away]">
              <template v-for="role in roleOrder">
                <tr>
                  <th class="subtitle" colspan="15">{{team.name}} - {{role.name}}</th>
                </tr>
                <tr class="stats-row"
                  v-for="playerKey in match.teams[team.key].players"
                  xxif="match.players[playerKey].stats.minutes_played > 0 && match.players[playerKey].role == role.key"
                  v-if="shouldShow(match.players[playerKey], role)"
                  :key="playerKey">
                  <th
                    scope="row"
                    @click="onPlayerSelected(playerKey)"
                    class="clickable">{{match.players[playerKey].jersey_name}} <small v-if="role.keys == null">{{match.players[playerKey].role}}</small></th>
                  <td>{{match.players[playerKey].stats.penalties_shootout.missed}}</td>
                  <td>{{match.players[playerKey].stats.penalties_shootout.saved}}</td>
                  <td>{{match.players[playerKey].stats.penalties_shootout.scored}}</td>
                </tr>
              </template>
            </template>
          </table>
        </section>
      </div>
    </div>
    <div v-if="activeSection.isManualStats">
      <football-manual-stats :match="match" @playerSelected="onPlayerSelected"></football-manual-stats>
    </div>
  </div>
</template>
<script>
import { Enum } from '@/helpers/enum'
import FootballManualStats from '@/components/football/FootballManualStats.vue'
export const StatsViewSection = new Enum({
  Overview: 'overview',
  LiveStats: 'live stats',
  ManualStats: 'manual stats'
})
export const OverviewSection = new Enum({
  Summary: 'summary',
  Attack: 'attack',
  Defence: 'defence',
  Passing: 'passing',
  Fouls: 'fouls',
  Goalkeeper: 'goalkeeper',
  Shootout: 'shootout'
})
export default {
  props: {
    match: Object
  },
  components: {
    'FootballManualStats': FootballManualStats
  },
  data () {
    return {
      roleOrder: [
        { keys: ['goalkeeper'], name: 'Goalkeepers' },
        { keys: ['defender'], name: 'Defenders' },
        { keys: ['midfielder'], name: 'Midfielder' },
        { keys: ['striker'], name: 'Strikers' },
        { keys: null, name: 'Others' }
      ],
      statsOrder: [
        { key: 'possession' },
        { key: 'shot_on_target' },
        { key: 'passes' },
        { key: 'tackles' },
        { key: 'corner_kicks' },
        { key: 'offsides' },
        { key: 'yellowcards' },
        { key: 'fouls' },
        { key: 'fouls_drawn' },
        { key: 'goal_saved' },
        { key: 'goals' },
        { key: 'own_goals' },
        { key: 'penalty_goals' },
        { key: 'redcards' }
      ],
      activeSection: StatsViewSection.Overview,
      overviewActiveSection: OverviewSection.Summary,
      sections: [],
      overviewActions: []
    }
  },
  mounted () {
    if (this.match.stats) {
      let newSections = [StatsViewSection.Overview]
      newSections.push(StatsViewSection.LiveStats)
      newSections.push(StatsViewSection.ManualStats)
      this.sections = newSections

      let newOverviewActions = [OverviewSection.Summary]
      newOverviewActions.push(OverviewSection.Attack)
      newOverviewActions.push(OverviewSection.Defence)
      newOverviewActions.push(OverviewSection.Passing)
      newOverviewActions.push(OverviewSection.Fouls)
      newOverviewActions.push(OverviewSection.Goalkeeper)
      newOverviewActions.push(OverviewSection.Shootout)
      this.overviewActions = newOverviewActions
    }
  },
  methods: {
    shouldShow (player, for_role) {
      if (player.stats.minutes_played > 0) {
        const player_role = player.role.value
        if (for_role.keys == null) {
          let allRoles = []
          this.roleOrder.forEach((role) => {
            if (role.keys != null) {
              allRoles = allRoles.concat(role.keys)
            }
          })
          if (allRoles.indexOf(player_role) == -1) {
            return true
          }
        } else {
          if (for_role.keys.indexOf(player_role) > -1) {
            return true
          }
        }
      }
      return false
    },
    onPlayerSelected (playerKey) {
      this.$emit('playerSelected', playerKey)
    }
  }
}
</script>
